import React from 'react';

const PaymentExecutorFlag = ({
  visible,
  formData,
  onChange,
  disabled = false,
}) => {
  if (!visible) return null;

  return (
    <div className="col-span-2 sm:col-span-2 lg:col-span-5 mt-1">
      <label className="flex items-start gap-2 p-3 rounded-xl border border-amber-200 bg-amber-50">
        <input
          type="checkbox"
          name="can_execute_payments"
          checked={Boolean(formData.can_execute_payments)}
          onChange={onChange}
          disabled={disabled}
          className="mt-0.5 w-4 h-4 text-amber-600 border-gray-300 rounded"
        />
        <span>
          <span className="block text-sm font-medium text-gray-800">Can execute daily payments</span>
          <span className="block text-xs text-gray-500">
            RV sir / payment executor. Shows Daily Payments and can mark Admin-approved agent indents as paid.
          </span>
        </span>
      </label>
    </div>
  );
};

export default PaymentExecutorFlag;
